import { createDiaryHooks } from '../factory'
import { deleteIntermediaryDiary, downloadIntermediaryDiaryPdf, getIntermediaryDiaries, getIntermediaryDiary, updateIntermediaryDiary } from './functions'

const intermediaryDiary = createDiaryHooks('intermediaryDiary', {
    getDiaries: getIntermediaryDiaries,
    getDiary: getIntermediaryDiary,
    updateDiary: updateIntermediaryDiary,
    deleteDiary: deleteIntermediaryDiary,
    downloadDiaryPdf: downloadIntermediaryDiaryPdf,
})

export default intermediaryDiary
